import React from 'react';
import { Seo } from '../shared';
import KnowledgeHubLayout from '../explore/KnowledgeHubLayout';
import DiscoverySection from '../explore/DiscoverySection';
import CategoryGuidesSection from './CategoryGuidesSection';
import { TRENDS_HUB } from '../../data/trendsHubContent';
import { EXPLORE_IMAGES } from '../../data/exploreImages';

function TrendsHubPage() {
	const hub = TRENDS_HUB;

	return (
		<KnowledgeHubLayout
			touristSection="discover"
			touristCurrent="Trends"
			hideRelated
			seo={(
				<Seo
					title="Trending in Nepal — Digital Nomads, Community Treks & More"
					path="/travel-trends"
					description="What's trending in Nepal travel — digital nomad life, community treks, wellness retreats, photography circuits, and monsoon-season alternatives beyond Everest and Pokhara."
				/>
			)}
			hero={{
				image: EXPLORE_IMAGES.trekking,
				eyebrow: 'Discover Nepal',
				title: hub.title,
				lead: hub.lead,
			}}
			intro={{
				title: 'Beyond the classics',
				text: 'Nepal travel is evolving — these are the trends shaping how visitors explore in 2026.',
				body: 'Everest and Pokhara remain essential, but repeat visitors and long-stay travelers are discovering community lodges, rain-shadow monsoon routes, and city-based remote work hubs.',
			}}
			faqs={hub.faqs}
		>
			<DiscoverySection eyebrow="Trends" title="What travelers are choosing now">
				{hub.sections.map((s, i) => (
					<div key={s.id} id={s.id} className="info-card arrival-step-card" style={{ marginBottom: '1.25rem' }}>
						<div className="info-card__body">
							<span className="arrival-step-card__num">Trend {i + 1}</span>
							<h3 className="info-card__title">{s.question}</h3>
							<p className="info-card__text">{s.answer}</p>
						</div>
					</div>
				))}
			</DiscoverySection>
			<CategoryGuidesSection
				category="trends"
				title="Trending guides"
				intro="Articles from our knowledge library — digital nomad life, photography etiquette, and more."
				alt
			/>
		</KnowledgeHubLayout>
	);
}

export default TrendsHubPage;
